<template>
  <div class="page-add notice-page">
    <div class="add-title">
      通知公告详情
    </div>
    <div class="notice-main">

      <div class="no-content">
        <div class="no-main">
          <div class="no-title">{{ ruleForm.noticeTitle || '' }}</div>
          <div class="no-tips">{{ ruleForm.onlineDate || '' }}</div>
          <div class="ql-container ql-snow">
            <div class="ql-editor">
              <div class="no-info" v-html="ruleForm.noticeContent"></div>
            </div>
          </div>
          <div v-if="ruleForm.attachmentList && ruleForm.attachmentList.length > 0">
            <div v-for="item in ruleForm.attachmentList" :key="item.uuid" class="no-file">
              <div class="nf-left">{{ item.name }}</div>
              <div class="nf-right" @click="fileDown(item)">下载</div>
            </div>
          </div>
        </div>
      </div>

      <el-form :model="ruleForm" ref="ruleForm" size="small" label-width="100px" class="notice-form">
        <el-form-item label="过期日期：" required>
          <div>{{ ruleForm.expireTime || '' }}</div>
        </el-form-item>
        <el-form-item label="是否置顶：" prop="setTop" required >
          <div>{{ ruleForm.setTop }}</div>
        </el-form-item>
        <div style="text-align: center;">
          <el-button @click="goBack">返回</el-button>
        </div>
      </el-form>

      
    </div>
    
  </div>
</template>

<script>

import { noticeDetail } from "@/api/notice";
import { downloadByUrl } from "@/utils/common.js";

export default {
  components: {
  },
  data() {
    return {
      ruleForm: {
        setTop: "0",
        attachmentList: []
      },
    };
  },
  created() {
    noticeDetail(this.$route.query.uuid).then(res => {
      const { data } = res;
      this.ruleForm = { ...data };
      this.ruleForm.setTop = data.setTop == 1 ? "是" : "否";
      this.ruleForm.attachmentList = JSON.parse(data.attachment) || [];      
    });
  },
  methods: {
    goBack() {
      this.$router.push('/notice');
    },

    fileDown(item) {
      downloadByUrl(item.name, item.url)
    },
  }
};
</script>
<style lang="scss" scoped>
.notice-page {
}
.notice-main {
  display: flex;
  flex-direction: column;

  .notice-form {
    // flex: 1;
  }
  .no-content {
    width: 100%;
    display: flex;
    justify-content: center;
    background: #f4f5f6;
    padding: 24px;
    margin-bottom: 16px;
  }
}


.no-main {
  background: #fff;
  width: 1000px;
  padding: 12px 24px;
  overflow-y: auto;
  .no-title {
    font-weight: 600;
    color: rgba(52, 60, 74, 1);
    font-size: 24px;
    line-height: 50px;
  }

  .no-tips {
    color: rgba(81, 98, 125, 1);
  }

  .no-bo {
    border: none;
  }

  .no-info {
    line-height: 32px;
    font-size: 16px;
    font-weight: 500;
  }

  .no-file {
    padding: 24px 16px;
    display: flex;
    justify-content: space-between;
    font-size: 16px;
    background: #f2f2f4;
    border-radius: 6px;
    margin-bottom: 12px;

    .nf-left {
      flex: 1;
      color: rgba(52, 60, 74, 1);
    }

    .nf-right {
      cursor: pointer;
      color: rgba(58, 133, 255, 1);
    }
  }
}
</style>
